import { gql } from '@apollo/client'

export const CREATE_DISCOUNT_PLAN = gql`
    mutation createShareAndDiscount($share_and_discount: ShareAndDiscountInput!) {
        createShareAndDiscount(share_and_discount: $share_and_discount) {
            code
            success
            message
        }
    }
`

export const UPDATE_REFERRAL_SYSTEM_PLAN = gql`
    mutation updateReferralSystem($id: NonEmptyString!, $referral_systems: ReferralSystemInput!) {
        updateReferralSystem(id: $id, referral_systems: $referral_systems) {
            code
            success
            message
        }
    }
`

export const ACTIVATE_REFERRAL_PLAN = gql`
    mutation updateReferralSystemStatus($id: NonEmptyString!, $discount_status: DiscountStatus!) {
        updateReferralSystemStatus(id: $id, discount_status: $discount_status) {
            code
            success
            message
        }
    }
`
